module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/03-01.a26d21e2.mp3";